import {queryHttp} from "~/query/queryHttp";
import {notificationStore} from "~/stores/init";
import {complianceArtifactDownloadUrl} from "~/pages/supplier-360/services/supplier360Urls";

/**
 * Opens one evidence file in a new tab (§2.9 `download-url/`). The link is minted per click, same
 * as the Contract Explorer's documents, so the permission check runs server-side.
 */
export async function openEvidenceFile(artifactId: number): Promise<void> {
    try {
        const {data} = await queryHttp.get<{download_url: string}>(complianceArtifactDownloadUrl(artifactId));
        window.open(data.download_url, '_blank', 'noopener,noreferrer');
    } catch {
        notificationStore.show('Could not open the evidence file. Please try again.', {
            severity: 'error',
            id: `compliance-artifact-download-error-${artifactId}`,
            autoHideDuration: 4000,
        });
    }
}
